<template>
  <modal background>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ video.title }}</p>
        <button
          class="delete"
          type="button"
          aria-label="close"
          @click="cancel"
        ></button>
      </header>

      <section class="modal-card-body">
        <p>
          Całkowita liczba wyświetleń filmu:
          <strong>{{ stats.total }}</strong>
        </p>
        <time-statistics
          title="Liczba wyświetleń (dziennie)"
          color="primary"
          :data="stats.daily"
          @request="requestVideoStatistics({ daily: $event })"
        />
        <time-statistics
          title="Liczba wyświetleń (miesięcznie)"
          color="primary2"
          :data="stats.monthly"
          @request="requestVideoStatistics({ monthly: $event })"
        />
      </section>

      <footer class="modal-card-foot">
        <button class="button" @click="cancel">
          Zamknij
        </button>
      </footer>
    </div>
  </modal>
</template>

<script>
import { mapState } from "vuex";

import { Modal } from "%modals";

import { REQUEST_VIDEO_STATISTICS } from ":actions";

import TimeStatistics from "%admin/components/global/TimeStatistics";

export default {
  name: "video-statistics-modal",

  components: {
    Modal,
    TimeStatistics
  },

  props: {
    video: Object
  },

  computed: mapState({
    stats: state => state.statistics.video
  }),

  mounted() {
    this.requestVideoStatistics({ daily: {}, monthly: {}, total: {} });
  },

  methods: {
    cancel() {
      this.$emit("hide");
    },

    requestVideoStatistics({ daily, monthly, total }) {
      this.$store.dispatch(REQUEST_VIDEO_STATISTICS, {
        daily,
        monthly,
        total,
        id: this.video.id
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-card {
  min-width: 60rem;
}
</style>
